module.exports = __webpack_public_path__ + "static/media/niveau-03.a312625a.png";